/**
 * Módulos toggleables de la plataforma — espejo exacto de
 * apps/core/src/lib/modules.ts. Mismos strings que ya usa `currentPage`.
 * "settings" y el Dashboard quedan fuera: siempre visibles, no toggleables.
 */
export const ALL_MODULE_KEYS = [
  'soil', 'weather', 'pest', 'battery',
  'locations', 'alerts', 'thresholds', 'reports',
  'mapas',
] as const;

export type ModuleKey = typeof ALL_MODULE_KEYS[number];

export const MODULE_LABELS: Record<ModuleKey, { icon: string; labelKey: string }> = {
  soil:       { icon: '🌱', labelKey: 'sidebar.nav.soil' },
  weather:    { icon: '🌤', labelKey: 'sidebar.nav.weather' },
  pest:       { icon: '🐛', labelKey: 'sidebar.nav.pest' },
  battery:    { icon: '🔋', labelKey: 'admin.modules.battery' },
  locations:  { icon: '📍', labelKey: 'admin.modules.locations' },
  alerts:     { icon: '🔔', labelKey: 'admin.modules.alerts' },
  thresholds: { icon: '📊', labelKey: 'admin.modules.thresholds' },
  mapas:      { icon: '🗺', labelKey: 'admin.modules.mapas' },
  reports:    { icon: '📋', labelKey: 'admin.modules.reports' },
};
